module.exports = __webpack_public_path__ + "static/media/acct_application-updates.1690b02a.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/acct_application-updates.md
// module id = 1075
// module chunks = 0